export const CREDIT_OPERATIONS_TABLE_ARIA_LABEL = 'Кредитні операції в інших установах';
export const CREDIT_OPERATIONS_TABLE_MIN_WIDTH = 1468;
export const CREDIT_OPERATIONS_DATE_COLUMN_INDEXES = [6, 7] as const;

export const CREDIT_OPERATIONS_TABLE_HEADERS = [
  'Кредитор',
  'Тип продукту',
  'Валюта',
  'Ліміт, тис. од.',
  'Заборгованість, тис. од.',
  'Процентна ставка, %',
  'Дата надання',
  'Дата погашення за договором',
  'Прострочення заборгованості, тис. од.',
] as const;

export const CREDIT_OPERATIONS_TABLE_COLUMN_WIDTHS = [
  '300px',
  '150px',
  '110px',
  '145px',
  '175px',
  '110px',
  '140px',
  '140px',
  '150px',
] as const;
